import { InputAdornment } from '@mui/material';

import { TextField } from 'src/components/TextField';

interface FixedCardNumberFieldProps {
  cardEnding: string;
  cardLogoPath: string;
  expiration: string;
}

const FixedCardNumberField = (props: FixedCardNumberFieldProps) => {
  const { cardEnding, cardLogoPath, expiration } = props;

  return (
    <TextField
      sizeVariant="medium"
      value={cardEnding}
      disabled
      variant="outlined"
      fullWidth
      InputProps={{
        classes: {
          disabled: 'text-hover-border',
        },
        startAdornment: (
          <InputAdornment className="[&>p]:text-hover-border" position="start">
            <div className="flex items-center gap-2">
              <img src={cardLogoPath} className="w-7" alt="card-logo" />
              •••• •••• ••••
            </div>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment className="pr-5" position="end">
            <span className="text-hover-border"> {expiration} •••</span>
          </InputAdornment>
        ),
      }}
      className="[&>div>fieldset]:border-non-hover-border! "
    />
  );
};

export default FixedCardNumberField;
